import React from 'react';
import { ProductRecommendations } from 'store/product/types';
import cn from 'classnames';
import { Recommendation } from 'store/landing/slice';
import { Theme } from 'store/landing/types';
import ProductItemPreview from '../ProductItemPreview/ProductItemPreview';
import styles from './Recommendations.module.scss';
import ProductCarousel from '../ProductCarousel/ProductCarousel';

export interface OwnProps {
  source: ProductRecommendations;
  sectionHeader: string;
  gaTrackingHandler?: (product: Recommendation) => void;
  theme?: Theme;
}

const Recommendations = ({ source, sectionHeader, theme = 'default', gaTrackingHandler }: OwnProps) => {
  const onClick = (product: Recommendation) => {
    if (gaTrackingHandler) {
      gaTrackingHandler(product);
    }
  };

  return (
    <>
      {source.products.length ? (
        <section className={cn(styles.recommendations, styles[`theme-${theme}`])}>
          <ProductCarousel progressBar theme={theme} title={sectionHeader}>
            {source.products.map((product: Recommendation, index: number) => (
              <div
                key={`product${index}`}
                data-product-id={product.productId}
                data-name={product.name}
                data-category-id={product.categoryId}
              >
                <ProductItemPreview
                  showPrice
                  productId={product.productId}
                  categoryId={product.categoryId}
                  productName={product.name || ''}
                  productThumbnail={product.thumbnail}
                  productUrl={product.url || ''}
                  theme={theme}
                  initialPrice={product.initialPrice?.value}
                  initialPriceFormatted={product.initialPrice?.formatted}
                  finalPrice={product.finalPrice?.value}
                  finalPriceFormatted={product.finalPrice?.formatted}
                  onClick={() => {
                    onClick(product);
                  }}
                />
              </div>
            ))}
          </ProductCarousel>
        </section>
      ) : null}
    </>
  );
};

export default Recommendations;
